import { useLoginStore } from "@/store/login";
import { useUserStore } from "@/store/user";
import { useMembershipFullscreenStore } from "./store";
import type { OpenMembershipFullscreenOptions } from "./types";
import { beginFullscreenPresentation } from "./presentation";

/** 打开独立会员全屏层；未登录时仅展示登录弹窗，不排队续开。 */
export function openMembershipFullscreenModal(options: OpenMembershipFullscreenOptions = {}): void {
  if (!useUserStore().isLogin) {
    useLoginStore().open = true;
    return;
  }
  const state = useMembershipFullscreenStore();
  if (state.mounted) return;
  beginFullscreenPresentation(options);
  state.show(options);
}

/** 关闭全屏会员层，动画结束后由宿主释放实例。 */
export function closeMembershipFullscreenModal(): void {
  useMembershipFullscreenStore().close();
}
